import * as React from "react";
import type { BrandingPublic } from "@/lib/branding/types";

/**
 * Branding context for the learner portal (Phase F2c).
 *
 * Surfaces the fetched public branding so leaf components (e.g.
 * `InstitutionMark`) can render the tenant's real `logo_url` instead of
 * the vertical-glyph placeholder. `undefined` while loading / on the bare
 * dev host, in which case consumers fall back to their placeholder.
 */
export interface TenantBrandingContextValue {
  branding: BrandingPublic | undefined;
  isLoading: boolean;
}

export const TenantBrandingContext = React.createContext<TenantBrandingContextValue>({
  branding: undefined,
  isLoading: false,
});

export function useTenantBrandingContext(): TenantBrandingContextValue {
  return React.useContext(TenantBrandingContext);
}
